import * as tslib_1 from "tslib";
import { OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var SEARCH_QUERY = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query searchMaintenanceTypes($where: MaintenanceTypeWhereInput) {\n    maintenanceTypes(\n      where: $where\n      orderBy: name_asc\n      limit: 100\n      offset: 0\n    ){\n      items {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query searchMaintenanceTypes($where: MaintenanceTypeWhereInput) {\n    maintenanceTypes(\n      where: $where\n      orderBy: name_asc\n      limit: 100\n      offset: 0\n    ){\n      items {\n        id\n        name\n      }\n    }\n  }\n"])));
var FcMaintenanceTypeInputComponent = /** @class */ (function () {
    function FcMaintenanceTypeInputComponent(apollo, fuseTranslationLoaderService) {
        this.apollo = apollo;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.legacyStyle = false;
        this.showSearchIcon = false;
        this.requiredMark = false;
        this.preloadOptions = true;
        this.searchOnFocus = false;
        this.options = [];
        this.isDuplicatedForm = false;
        this.showAllMaintenanceTypesOption = false;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.search = this.search.bind(this);
        this.displayWith = this.displayWith.bind(this);
    }
    FcMaintenanceTypeInputComponent.prototype.ngOnChanges = function (changes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var selectedValuesIsEmpty, hasDisplayText, selectedSegment, hasMaintenanceTypes, hasSegmentMaintenanceTypeForms, controlValuesIsNull, _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        selectedValuesIsEmpty = changes.control && changes.control.currentValue && changes.control.currentValue.value && (changes.control.currentValue.value.value === '');
                        hasDisplayText = changes.displayText && changes.displayText.currentValue;
                        if (selectedValuesIsEmpty && !hasDisplayText) {
                            this.control.setValue(null);
                        }
                        if (!(changes.selectedSegment && changes.selectedSegment.currentValue)) return [3 /*break*/, 4];
                        selectedSegment = changes.selectedSegment.currentValue;
                        hasMaintenanceTypes = !!(selectedSegment.maintenanceTypes && !selectedSegment.maintenanceTypes.length);
                        hasSegmentMaintenanceTypeForms = !!(changes.selectedSegment.currentValue.segmentMaintenanceTypeForms);
                        controlValuesIsNull = changes.control && changes.control.currentValue && changes.control.currentValue.value === null;
                        if (!(hasMaintenanceTypes || (hasSegmentMaintenanceTypeForms && controlValuesIsNull))) return [3 /*break*/, 2];
                        this.selectedSegment = null;
                        _a = this;
                        return [4 /*yield*/, this.search('')];
                    case 1:
                        _a.options = _c.sent();
                        return [2 /*return*/];
                    case 2:
                        this.selectedSegment = changes.selectedSegment.currentValue;
                        _b = this;
                        return [4 /*yield*/, this.search('')];
                    case 3:
                        _b.options = _c.sent();
                        _c.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FcMaintenanceTypeInputComponent.prototype.search = function (searchTerm) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: SEARCH_QUERY,
                        variables: {
                            where: {
                                segmentId: this.selectedSegment && this.selectedSegment.id ? this.selectedSegment.id : null,
                                name_contains: searchTerm,
                                archived: false
                            },
                        },
                    })
                        .toPromise()
                        .then(function (result) {
                        return result.data['maintenanceTypes']['items'];
                    })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return [];
                    })];
            });
        });
    };
    FcMaintenanceTypeInputComponent.prototype.displayWith = function (value) {
        return value && value.name;
    };
    return FcMaintenanceTypeInputComponent;
}());
export { FcMaintenanceTypeInputComponent };
var templateObject_1;
